import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useApiSelect } from '../../api/common/apiSelect';
import { createAPI } from '../../composable/useAPI'

function UpTime() {
    const session = useSelector((s) => s.session.data);
    const { request } = useApiSelect();
    const [machines, setMachines] = useState([]);
    const [loading, setLoading] = useState(false);
    const [err, setErr] = useState(null);
    const [formData, setFormData] = useState({ machineSeq: '', dt: '' , onTime : 0, companySeq : 1});

    const api = createAPI();
    const add = async (data) => {
        try {
            data.companySeq = session.companySeq;
            const response = await api.post('/api/v2/machine/onTime', data);
            if(response.status === 200){
                alert("등록")
            } else {
                alert("실패")
            }
            
        } catch (error) {
            console.error('POST request failed:', error);
            return false;
        }
    };

    useEffect(() => {
        if (!session?.companySeq) return;
        (async () => {
            try {
                setLoading(true);
                setErr(null);
                const res = await request.machine(
                    { companySeq: session.companySeq },
                );
                setMachines(res);
            } catch (e) {
                console.error(e);
            } finally {
                setLoading(false);
            }
        })();
    }, [session?.companySeq]); 

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((p) => ({ ...p, [name]: value }));
    };

    return (
        <div>
            
            <select
                name="machineSeq"
                id="machineSeq"
                value={formData.machineSeq}
                onChange={handleChange}
                disabled={loading || machines.length === 0}
                className="floating-input floating-date"
            >
                <option value="">{loading ? '불러오는 중...' : '선택'}</option>
                    {machines.map((m) => (
                    <option key={m.machineSeq} value={m.machineSeq}>
                    {m.machineName}
                </option>))}
            </select>
            <input
                type="date"
                name="dt"
                id="dt"
                value={formData.dt}
                onChange={handleChange}
                className="floating-input floating-date"
            />
            <select
                name="type"
                id="type"
                value={formData.type}
                onChange={handleChange}
                className="floating-input floating-date"
            >
                <option value="">선택</option>
                <option value="1">가동시간</option>
                <option value="2">전원시간</option>
            </select>
            <input
                type="number"
                name="onTime"
                id="onTime"
                value={formData.onTime}
                onChange={handleChange}
                className="floating-input floating-date"
            />
            <button onClick={() => {add(formData)}}>추가</button>
            {err && <div className="error">{err}</div>}
        </div>
    );
}

export default UpTime;
